define.alias("ember-math-helpers/helpers/mod", "media/helpers/mod");